<template>
	<div
		itemprop="itemListElement" itemscope itemtype="https://schema.org/LodgingBusiness"
		class="feriehus-item" :class="'imp_'+lodging.postMeta.esName.toLowerCase()"
		:id="translatedId"
		:data-daysold="lodging.postMeta.daysSince"
		:data-post-id="lodging.post_ID"
		:data-lodging-id="lodging.postMeta.esLodgingId"
		:data-lat="lodging.postMeta.esLatitude"
		:data-lng="lodging.postMeta.esLongitude"
	>
		<meta itemprop="name" :content="lodging.postMeta.esName" />
		<meta itemprop="telephone" content="97 31 55 40" />
		<last-minute-header v-if="displayLastMinuteHeader" :lodging="lodging" />
		<div class='feriehus-inner-item'>
			<title-display :lodging="lodging" class="visible-xs mobile-title" :displaySchema="true" />
			<div class="col first">
				<template v-if="typeof lodging.images !== 'undefined' && lodging.images.length > 0 ">
					<div class="mobile-slider-navigation mobile-slider-next"></div>
					<div class="mobile-slider-navigation mobile-slider-previous"></div>
				</template>
				<div class="img-wrap" :data-url="parsedUrl">
					<template v-if="typeof lodging.images !== 'undefined' && lodging.images.length > 0 ">
						<a v-for="(image, index) in lodging.images" class="lodging-image" :data-index="index" :class="{'primary': index === 0, 'modelfoto':image.tags === 'modelfoto', 'renoveres': image.tags ==='renoveres','de':isGerman}" :href="parsedUrl">
							<img itemprop="image" class="img-responsive" :class="{'primary': index === 0}" :src="handleImage(scaledImagePaths[index])" :alt="image.alt" />
						</a>
					</template>
					<template v-else>
						<a :href="parsedUrl"><img itemprop="image" class="primary img-responsive tempPlaceHolderImageInItem" :src="noImagePath" :alt="translations.sentences.imagePending" /></a>
					</template>
					<div v-if="isLastMinute === true" class="last-minute-period">
						<div class="last-minute-inner">
							{{arrivalFormatted}} {{translations.terms.to}} {{departureFormatted}} ({{durationFormatted}})
						</div>
					</div>
					<div class="clearfix"></div>
				</div>
			</div>
			<div class="col scnd">
				<title-display :lodging="lodging" class="hidden-xs" />
				<div class="basic-data">
					<div class="row"><span class="type">{{translations.searchFilterNames[156]}}:</span><span class="value" itemprop="maximumAttendeeCapacity">{{lodging.facilities[156]}}</span></div>
					<div class="row"><span class="type">{{translations.searchFilterNames.husdyr}}:</span><span class="value" itemprop="petsAllowed" content="https://schema.org/True">{{petsDisplay}}</span></div>
					<div class="row" itemprop="amenityFeature" itemscope itemtype="https://schema.org/LocationFeatureSpecification"><span class="type" itemprop="unitText">{{translations.searchFilterNames[179]}}:</span><span class="value"><span itemprop="value">{{lodging.facilities[179]}}</span> <span itemprop="unitCode" content="MTR">m</span></span></div>
					<div class="row"><span class="type">{{translations.terms.area}}:</span><span class="value" itemprop="areaServed">{{lodging.postMeta.esAddress2}}</span></div>
					<div class="row"><span class="type">{{translations.searchFilterNames.skiftedag}}:</span><span class="value" itemprop="checkinTime" :content="changedayShorthands">{{changedayDisplay}}</span></div>
					<div v-if="freeCleaningEnabled" class="row yellow"><span class="type">{{translations.terms.endCleaning}}:</span><span class="value">{{translations.terms.FREE}}</span></div>
				</div>
			</div>
			<div class="col text-right third">
				<star-display :stars="lodging.facilities[207]" />
				<favorite-heart :postId="Number(lodging.post_ID)"/>
				<price-display :lodging="lodging" />
			</div>
			<div class="clearfix"></div>
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
	import StarDisplay from "@vue/components/stars/StarDisplay.vue";
	import FavoriteHeart from "@vue/components/favorites/FavoriteHeart.vue";
	import PriceDisplay from "@vue/components/search/itemParts/PriceDisplay.vue";
	import LastMinuteHeader from "@vue/components/search/itemParts/LastMinuteHeader.vue";
	import TitleDisplay from "@vue/components/search/itemParts/TitleDisplay.vue";
	import {buildDateFromString} from "@js/globalFunctions/dateHandling";
	import {mapState} from 'vuex';
	export default {
		components: {
			StarDisplay,
			FavoriteHeart,
			PriceDisplay,
			LastMinuteHeader,
			TitleDisplay
		},
		methods: {
			handleImage(image){
				return this.useRemoteLodgingImages === true ? image.replace(window.location.hostname.replace('.de','.dk'),'esmark.dk').replace('http:','https:') : image ;
			},
			isValidDate(d) {
				return d instanceof Date && !isNaN(d);
			}
		},
		computed: {
			...mapState({
				translations: 'translations',
				useRemoteLodgingImages: 'useRemoteLodgingImages',
				isLastMinute: 'isLastMinute',
				windowWidth: 'windowWidth'
			}),
			parsedUrl(){
				if(window.isDev)
					return this.lodging.url.replace('https://esmark.dk','http://esmarklocal.dk');

				if(window.location.hostname === 'vesterland.dk')
					return this.lodging.url.replace('esmark.dk','vesterland.dk');

				if(window.location.hostname === 'westerland.dk')
					return this.lodging.url.replace('esmark.de','westerland.dk');

				return this.lodging.url;
			},
			isGerman(){
				return siteID === '2';
			},
			noImagePath(){
				return (siteID === '1') ? themeUrl+'/gfx/dk/billede_paa_vej_ny.jpg' :themeUrl+'/gfx/de/billede_paa_vej_ny.jpg' ;
			},
			scaledImagePaths(){
				if(typeof this.lodging.images === 'undefined' || this.lodging.images.length === 0)
					return [];
				let paths = [];
				const windowWidth = this.windowWidth;
				this.lodging.images.forEach((image) => {
					let url = image.url;
					if(windowWidth <= 400){
						url = url.replace('262x185','382x253')
					}
					else if(windowWidth < 970){
						url = url.replace('262x185','442x307')
					}
					paths.push(url);
				});
				return paths;
			},
			translatedId(){
				return (this.translations.terms.VacationHouse+'-'+this.lodging.postMeta.esName).toLowerCase();
			},
			petsDisplay(){
				let displayState = this.translations.terms.no;
				if(this.lodging.facilities[149] === 'True')
				{
					if( this.lodging.facilities[150] !== '' && !isNaN(this.lodging.facilities[150]) )
					{
						displayState = this.translations.sentences.yesMaxX.replace('%i',this.lodging.facilities[150]);
					}
					else
					{
						displayState = this.translations.sentences.yesMaxX.replace('%i','2');
					}
				}
				return displayState;
			},
			arrivalDate(){
				return buildDateFromString(this.lodging.datestring,'yyyy-mm-dd');
			},
			changeDay(){
				const possibles = [
					204,
					203,
					247,
					275,
					281
				];
				for(let i = 0; i < possibles.length; i++)
				{
					if(typeof this.lodging.facilities[possibles[i]] !== 'undefined' && this.lodging.facilities[possibles[i]] !== 'False' && this.lodging.facilities[possibles[i]] !== '')
					{
						return possibles[i];
					}
				}
				return 204;
			},
			changedayDisplay(){
				if(this.arrivalDate !== false && this.isValidDate(this.arrivalDate)){
					const weekdays = {
						0: 'sunday',
						1: 'monday',
						2: 'tuesday',
						3: 'wednesday',
						4: 'thursday',
						5: 'friday',
						6: 'saturday'
					};
					return this.translations.weekdays[weekdays[this.arrivalDate.getDay()]];
				}

				const possibles = {
					204: 'saturday',
					203: 'friday',
					247: 'sunday',
					275: 'thursday',
					281: 'monday'
				};
				return this.translations.weekdays[possibles[this.changeDay]];
			},
			changedayShorthands()
			{
				const possibles = {
					204: 'Sa',
					203: 'Fr',
					247: 'Sun',
					275: 'Th',
					281: 'Mo'
				};
				return possibles[this.changeDay];
			},
			freeCleaningEnabled(){
				return (typeof this.lodging.facilities[9001] !== 'undefined' && this.lodging.facilities[9001] === 'True');
			},
			departureDate(){
				const departureDate = new Date();
				departureDate.setTime( this.arrivalDate.getTime() + this.lodging.duration * 86400000 );
				return departureDate;
			},
			arrivalFormatted(){
				return this.arrivalDate.getDate()  + "/" + (this.arrivalDate.getMonth()+1);
			},
			departureFormatted(){
				return this.departureDate.getDate()  + "/" + (this.departureDate.getMonth()+1);
			},
			durationFormatted(){
				if(this.lodging.duration % 7 === 0)
				{
					const weeks = this.lodging.duration/7;
					return (weeks === 1) ? '1 '+this.translations.terms.week : weeks+' '+this.translations.terms.weeks;
				}
				else
				{
					return (this.lodging.duration === 1) ? '1 '+this.translations.terms.day : this.lodging.duration+' '+this.translations.terms.days;
				}
			}
		},
		props:{
			lodging: Object,
			displayLastMinuteHeader: {
				type: Boolean,
				default: false
			}
		}
	}
</script>

<style scoped>

</style>
